import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { AiExplanation } from '@sloyd/ui';
import { useMemo } from 'react';
import styled from 'styled-components';

export type ExplanationContainerProps = {};

export function ExplanationContainer(_props: ExplanationContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const { aiExplanation } = appState;

  const callbacks = useMemo(
    () => ({
      clear: () => {
        dispatch(actions.appState.patch({ aiExplanation: '' }));
      },
    }),
    []
  );

  return (
    <Wrapper>
      <AiExplanation text={aiExplanation} callbacks={callbacks} />
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-450px);
  bottom: 80px;
  width: 640px;
  max-height: 120px;
`;

export default ExplanationContainer;
